import $ from 'jquery'
import {
  prepareChessboard,
  plotArrow
} from '../../utils';

/**
* @name lesson9Assignment1
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson9Assignment1(config) {
  let afterLoad = function () {
    prepareChessboard(config);

    $('#myCanvas').addClass('show').removeClass('hide');
    let c = document.getElementById("myCanvas"),
      ctx = c.getContext("2d");
    
    let from = document.getElementsByClassName("square-a1"),
      fromx = from[0].offsetParent.offsetLeft + from[0].offsetLeft,
      to = document.getElementsByClassName("square-b1"),
      tox = to[0].offsetParent.offsetLeft + to[0].offsetLeft;
    
    let squareEdge = tox-fromx;
    let arrowTail = squareEdge/7;
    let arrowHead = squareEdge/8;
    let arrowCompletion = ((arrowTail/squareEdge)*10)/2;
    
    ctx.clearRect(0, 0, c.width, c.height);
    plotArrow(ctx, "square-f3", "square-f5", null, null, null, 5-arrowCompletion, 0, arrowTail);
    plotArrow(ctx, "square-f3", "square-d3", null, null, null, null, 0, arrowTail);
    plotArrow(ctx, "square-f3", "square-f1", null, null, null, 5+arrowCompletion, 0, arrowTail);
    plotArrow(ctx, "square-f5", "square-e5", null, null, null, null, arrowHead, arrowTail);
    plotArrow(ctx, "square-d3", "square-d4", null, null, null, null, arrowHead, arrowTail);
    plotArrow(ctx, "square-d3", "square-d2", null, null, null, null, arrowHead, arrowTail);
    plotArrow(ctx, "square-f1", "square-e1", null, null, null, null, arrowHead, arrowTail);
  }

  const chessConfig = {
    config: {
      position: config.position,
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_9/assignments.js